import type { Notice, NoticeImageLayer, NoticeTextLayer, NoticeVideoLayer } from '@cornerstone/shared';
import { lowPowerClockNotice } from '@cornerstone/shared';

// 옛 글자 카탈로그 8종(환영 타이포·공간 이용 안내·기관 스포트라이트·활동 하이라이트·참여자 모집·행사 프로그램·
// 생활 공지·오늘의 정보 보드)과 시계·날씨 대기 화면 카드는 2026-10-01 대교 결정으로 지웠다 — 기본 템플릿은
// Figma 1~6번과 저전력 모드(시계)만. 운영에선 BO 숨김 목록으로 가려 두었는데 권한 적용 뒤 그 목록 조회가 막혀
// 다시 나타났고, 숨김이 아니라 삭제가 맞다고 정리됐다.

export type StationCNoticeLayer = NoticeTextLayer | NoticeImageLayer | NoticeVideoLayer;

/** Live-widget templates (clock / date / weather layers). Their layers are `dataWidget`s built in design pixels.
 * Figma: Station C 템플릿 — 7. 저전력 모드 (시계), node 1:1022 (2026-09-22). */
export type StationCWidgetTemplate = {
  id: string; category: string; name: string; description: string; canvasFill: string;
  build(canvasWidth: number, canvasHeight: number, durationSec: number): Pick<Notice, 'canvasWidth' | 'canvasHeight' | 'canvasFill' | 'canvasFillOpacity' | 'durationSec' | 'layers'>;
};
export const STATIONC_WIDGET_TEMPLATES: readonly StationCWidgetTemplate[] = [
  {
    id: 'low-power-clock', category: '대기 화면', name: '저전력 모드 (시계)', canvasFill: '#000000',
    description: '검은 배경에 시·분을 크게, 초는 오른쪽에서 왼쪽으로 흐르는 테이프로. 상단에 날씨 아이콘과 영문 요일·일',
    build(canvasWidth, canvasHeight, durationSec) {
      const draft = lowPowerClockNotice(canvasWidth, canvasHeight, durationSec);
      return { ...draft, layers: draft.layers.map((layer) => ({ ...layer, id: `stationc-${crypto.randomUUID()}` })) };
    },
  },
];
export type StationCNoticeDraft = {
  canvasWidth: number; canvasHeight: number; canvasFill: string; canvasFillOpacity: number;
  durationSec: number; layers: StationCNoticeLayer[];
};
